import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "21",
  height: "21",
  fill: "none",
  viewBox: "0 0 21 21"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "10.5",
      cy: "10.5",
      r: "10.125",
      fill: "url(#i-1361311112__a)"
    }, null, -1),
    _createElementVNode("defs", null, [
      _createElementVNode("linearGradient", {
        id: "i-1361311112__a",
        x1: "20.625",
        x2: "-1.313",
        y1: "4.172",
        y2: "9.234",
        gradientUnits: "userSpaceOnUse"
      }, [
        _createElementVNode("stop", { "stop-color": "#7AA459" }),
        _createElementVNode("stop", {
          offset: "1",
          "stop-color": "#213E26"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }